import script from "./buttonGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./buttonGroup.vue?vue&type=script&setup=true&lang=js"

import "./buttonGroup.vue?vue&type=style&index=0&id=2ceca339&scoped=true&lang=css"

import exportComponent from "D:\\newProjectGit\\HbzsbAdminClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ceca339"]])

export default __exports__